export const SHARED_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
    dbInput: 'YYYY-MM-DD',
    payPeriod: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MM/DD/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};